module.exports = __webpack_public_path__ + "assets/Excessive Overbite selected.db3544239bfaebed8e622e298c1b01f1.png";